/* eslint-disable import/prefer-default-export */

export const randomizeWidth = (width: number, percent: number) => {
  let randomValue = Math.random();

  if (Math.random() < 0.5) {
    randomValue = Math.min(randomValue, Math.random());
  } else {
    randomValue = Math.max(randomValue, Math.random());
  }

  const offset = width * (percent / 100);
  const randomizedOffset = randomValue * offset - offset / 2;
  return Math.round(width + randomizedOffset);
};
